import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
   fetchHotel,
   postHotelFeedback,
   postHotelUnsubscribe,
 } from './api';
// ------------------------------------
// Constants
// ------------------------------------
export const HOTEL_FEEDBACK_FAILURE = 'HOTEL_FEEDBACK_FAILURE';
export const HOTEL_FEEDBACK_REQUEST = 'HOTEL_FEEDBACK_REQUEST';
export const HOTEL_FEEDBACK_SUCCESS = 'HOTEL_FEEDBACK_SUCCESS';
export const HOTEL_FETCH_FAILURE = 'HOTEL_FETCH_FAILURE';
export const HOTEL_FETCH_REQUEST = 'HOTEL_FETCH_REQUEST';
export const HOTEL_FETCH_SUCCESS = 'HOTEL_FETCH_SUCCESS';
export const HOTEL_UNSUBSCRIBE_FAILURE = 'HOTEL_UNSUBSCRIBE_FAILURE';
export const HOTEL_UNSUBSCRIBE_REQUEST = 'HOTEL_UNSUBSCRIBE_REQUEST';
export const HOTEL_UNSUBSCRIBE_SUCCESS = 'HOTEL_UNSUBSCRIBE_SUCCESS';
// ------------------------------------
// Actions
// ------------------------------------
export function hotelFeedbackRequest() {
  return {
    type: HOTEL_FEEDBACK_REQUEST,
    payload: null,
  };
}
export function hotelFeedbackSuccess(json) {
  return {
    type: HOTEL_FEEDBACK_SUCCESS,
    payload: json,
  };
}
export function hotelFeedbackFailure(json) {
  return {
    type: HOTEL_FEEDBACK_FAILURE,
    payload: json,
  };
}
export function sendHotelFeedback(payload) {
  return (dispatch) => {
    dispatch(hotelFeedbackRequest());
    return postHotelFeedback(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'You have been removed from the hotel',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelFeedbackSuccess(response));
        dispatch(push('/'));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(hotelFeedbackFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeBid(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeBid(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function hotelUnsubscribeRequest() {
  return {
    type: HOTEL_UNSUBSCRIBE_REQUEST,
    payload: null,
  };
}
export function hotelUnsubscribeSuccess(json) {
  return {
    type: HOTEL_UNSUBSCRIBE_SUCCESS,
    payload: json,
  };
}
export function hotelUnsubscribeFailure(json) {
  return {
    type: HOTEL_UNSUBSCRIBE_FAILURE,
    payload: json,
  };
}
export function hotelUnsubscribe(id) {
  return (dispatch) => {
    dispatch(hotelUnsubscribeRequest());
    return postHotelUnsubscribe(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(hotelUnsubscribeSuccess(response));
        dispatch(push('/'));
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Unsubscribed',
          message: 'You are unsubscribed from this hotel.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Yikes!',
                message: 'Ugh. Something is wrong. Try again in a bit.',
                autoDismiss: 0,
                action: {
                  label: 'Retry',
                  callback: () => dispatch(hotelUnsubscribe(id)),
                },
              };
              dispatch(Notifications.error(notificationOpts));
              dispatch(hotelUnsubscribeFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status === 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Unsubscribed',
              message: 'You are already unsubscribed from this hotel.',
              autoDismiss: 0,
            };
            dispatch(Notifications.success(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function hotelFetchRequest() {
  return {
    type: HOTEL_FETCH_REQUEST,
    payload: null,
  };
}
export function hotelFetchSuccess(json) {
  return {
    type: HOTEL_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelFetchFailure(json) {
  return {
    type: HOTEL_FETCH_FAILURE,
    payload: json,
  };
}
export function loadHotel(payload) {
  return (dispatch) => {
    dispatch(hotelFetchRequest());
    return fetchHotel(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(hotelFetchSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(hotelFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [HOTEL_FEEDBACK_REQUEST]: state => update(
      state,
    {
      $set:
      {
        needFetch: false,
        isFetching: true,
        hotel: {},
      },
    },
    ),
  [HOTEL_FEEDBACK_SUCCESS]: (state, action) => {
    if (action.payload.length !== 0) {
      return update(
        state,
        {
          $set:
          {
            needFetch: false,
            isFetching: false,
          },
        },
      );
    }
    return state;
  },
  [HOTEL_FETCH_SUCCESS]: (state, action) => {
    return update(
      state,
      {
        $set:
        {
          needFetch: false,
          isFetching: false,
          hotel: action.payload,
        },
      },
    );
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: false,
  needFetch: true,
  hotel: null,
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/feedback/modules/feedback.js